module.exports = __webpack_public_path__ + "static/neon-20c2acab2c27797f4e3ad60227ab3b7b.png";